// @flow
import React from 'react';
import { isBrowser } from 'react-device-detect';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import './DisplayTab.scss';

type Props = {
  onClick: void,
  sort: ?string,
  onTab: boolean,
};

const DisplayTab = ({ onClick, sort, onTab }: Props) => (
  <div className="DisplayTab">
    <div className="spacer" />
    <div className={cx('dropdown', 'is-right', onTab ? 'is-active' : '')}>
      <div className={cx('dropdown-button', { desktop: isBrowser })}>
        <button
          className="button"
          onClick={onClick}
          aria-haspopup="true"
          aria-controls="dropdown-menu6"
        >
          <span>정렬</span>
          <span className="icon is-small">
            <i className="fas fa-angle-down" aria-hidden="true" />
          </span>
        </button>
      </div>
      <div className="dropdown-menu" id="dropdown-menu6" role="menu">
        <div className="dropdown-content" onClick={onClick}>
          <Link
            className={cx('dropdown-item', { active: sort === 'released_at-DESC' })}
            to="?sort=released_at-DESC"
          >
            날짜 오름차순
          </Link>
          <Link
            className={cx('dropdown-item', { active: sort === 'released_at-ASC' })}
            to="?sort=released_at-ASC"
          >
            날짜 내림차순
          </Link>
          <Link
            className={cx('dropdown-item', { active: sort === 'title-DESC' })}
            to="?sort=title-DESC"
          >
            제품명 오름차순
          </Link>
          <Link
            className={cx('dropdown-item', { active: sort === 'title-ASC' })}
            to="?sort=title-ASC"
          >
            제품명 내림차순
          </Link>
        </div>
      </div>
    </div>
  </div>
);

DisplayTab.defaultProps = {
  sort: 'released_at-DESC',
  onTab: false,
};

export default DisplayTab;



// WEBPACK FOOTER //
// ./src/components/display/DisplayTab/DisplayTab.js